
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import BPSection from './snippets/BPSection.vue'

type Partner = 'swisscom' | 'sunrise' | 'salt' | 'wingo' | 'yallo' | 'talktalk'

const partnerImagesMap: Record<Partner, any[]> = {
  salt: [require('~/assets/images/provider-logos/white/salt.png'), require('~/assets/images/provider-logos/white/salt@2x.png')],
  swisscom: [require('~/assets/images/provider-logos/white/swisscom.png'), require('~/assets/images/provider-logos/white/swisscom@2x.png')],
  talktalk: [require('~/assets/images/provider-logos/white/talktalk.png'), require('~/assets/images/provider-logos/white/talktalk@2x.png')],
  wingo: [require('~/assets/images/provider-logos/white/wingo.png'), require('~/assets/images/provider-logos/white/wingo@2x.png')],
  sunrise: [require('~/assets/images/provider-logos/white/sunrise.svg')],
  yallo: [require('~/assets/images/provider-logos/white/yallo.svg')],
}

@Component({
  components: {
    BPSection,
  },
})
export default class BPPartners extends Vue {
  @Prop({ type: Boolean, required: false, default: false })
  readonly withShadow!: boolean

  partnerLogos (partner: Partner) {
    const images = partnerImagesMap[partner]

    return {
      srcset: images.map((image, index) => `${image} ${index + 1}x`).join(', '),
      src: images[0],
    }
  }

  get partners () {
    return [
      {
        name: 'Swisscom',
        slug: 'swisscom',
        images: this.partnerLogos('swisscom'),
      },
      {
        name: 'Sunrise',
        slug: 'sunrise',
        images: this.partnerLogos('sunrise'),
      },
      {
        name: 'Salt',
        slug: 'salt',
        images: this.partnerLogos('salt'),
      },
      {
        name: 'Wingo',
        slug: 'wingo',
        images: this.partnerLogos('wingo'),
      },
      {
        name: 'Yallo',
        slug: 'yallo',
        images: this.partnerLogos('yallo'),
      },
      {
        name: 'TalkTalk',
        slug: 'talktalk',
        images: this.partnerLogos('talktalk'),
      },
    ]
  }
}
